// Generated by ReScript, PLEASE EDIT WITH CARE

import * as DeccoUtils$Catalyst from "../../../../../../node_modules/@porterin/catalyst/src/utils/DeccoUtils.bs.js";
import * as SendPaymentRequestApiModel from "../api-model/SendPaymentRequestApiModel.bs.js";

function decodeApiModel(data) {
  return {
          message: data.message
        };
}

function execute(json) {
  var data = DeccoUtils$Catalyst.resolveResult(SendPaymentRequestApiModel.t_decode(json), "SendPaymentRequestEntityMapper.re");
  return {
          message: data.message
        };
}

export {
  decodeApiModel ,
  execute ,
  
}
/* DeccoUtils-Catalyst Not a pure module */
